import { css } from "@emotion/css";

const styles = {
  icon: css`
    font-size: 16px !important;
  `,
};

export default styles;
